/**
 * @param {number} interestRate
 * @param {number} numberOfPeriods
 * @param {number} presentValue
 * @param {number} futureValue
 * @param {number} type
 * @returns {number}
 */
function generatePayment ({ interestRate = 0, numberOfPeriods = 0, presentValue = 0, futureValue = 0, type = 0 } = {}) {
  if (interestRate === 0) {
    return -(presentValue + futureValue)
  }

  const pvif = Math.pow(1 + interestRate, numberOfPeriods)
  let pmt = -interestRate * presentValue * (pvif + futureValue) / (pvif - 1)

  if (type === 1) {
    pmt /= (1 + interestRate)
  }

  return pmt
}

module.exports = { generatePayment }
